import _ from "lodash";
import * as z from "../../../framework";
import { identityServerSettings } from "../core";
import { usingAuth0, usingSso } from "../util/util";
import languageView from "./language.view";
import userPreferencesView from "./userPreferences.view";

export function handleUserNameClick() {
    $("#UserName").tie("click", function () {

        let showIdsInGrids = _.find(z.user.companyData.UserPreferences, function (userPreference: any) {
            return userPreference.UserPreferenceNumber == "ShowIdsInGrids";
        }) || {};

        const passwordResetButton = () => {
            if (z.settings.appSettings.disableChangePassword) {
                return [];
            }

            // disable password reset if user was authenticated with an SSO connection
            if (usingSso()) {
                return [];
            }

            return [{
                name: z.ll("ResetPassword"),
                clickEvent: function (e) {
                    if (!usingAuth0()) {
                        const emailAddress = encodeURIComponent(z.user.loginData.UserName);
                        const redirectBackURL = encodeURIComponent(window.location.href);
                        const forgotPasswordPage = `${identityServerSettings.authority}/ForgotPassword?Email=${emailAddress}&RedirectURL=${redirectBackURL}`;
                        window.location.href = forgotPasswordPage;
                        return;
                    }

                    popUp.window.wrapper.mask();
                    const Brand = z.util.getOptionValue("Brand", "servicepro");
                    const ChangePasswordUrl = window.location.origin;
                    const EmailAddress = z.user.loginData.UserName;
                    const data = { Brand, ChangePasswordUrl, EmailAddress };
                    z.ajax({
                        type: "POST",
                        url: "Password/RequestReset",
                        data: data,
                        errorHandled: true
                    }).done(function () {
                        z.controls.alert({
                            type: "success",
                            header: z.ll("EmailSent"),
                            message: z.ll("PasswordResetEmailSuccess")
                        });
                        popUp.window.wrapper.unmask();
                    }).fail(function () {
                        z.controls.alert({
                            type: "danger",
                            header: z.ll("EmailFailed"),
                            message: z.ll("PasswordResetEmailFailure")
                        });
                        popUp.window.wrapper.unmask();
                    });
                }
            }]
        }
        const saveButton = () => {
            if (usingSso()) {
                return [];
            }

            return[{
                name: z.ll("Save"),
                clickEvent: function (e) {

                    z.util.validate({
                        validator: popUp.guts.data("kendoValidator"),
                        e: e
                    });

                    if (!e.isDefaultPrevented()) {
                        e.preventDefault();
                        popUp.get("#UserPreferencesWindow").disableAll();
                        popUp.window.wrapper.mask();

                        const firstName = userPrefs.FirstName;
                        const lastName = userPrefs.LastName;
                        const nonFormattedCompanyData = localStorage.getItem("companyData");
                        const companyData = JSON.parse(nonFormattedCompanyData);

                        const dto = {
                            Id: companyData.EmployeeId,
                            FirstName: firstName,
                            LastName: lastName,
                        };
                        z.util.updateEntity({
                            entityType: "Employee",
                            dto: dto,
                            success: function (response, callback) {
                                callback();

                                z.controls.alert({
                                    type: "success",
                                    header: z.ll("SaveSuccessful"),
                                    message: z.ll("PreferencesSaveSuccessfulMessage")
                                });
                                popUp.window.close();

                                const fullName = `${firstName} ${lastName}`;
                                z.user.loginData.FirstName = firstName;
                                z.user.loginData.LastName = lastName;
                                z.user.loginData.FullName = fullName;
                                z.user.name = fullName;

                                $("#UserName").text(fullName);

                                localStorage.loginData = JSON.stringify(z.user.loginData);
                            },
                            error: function (response, callback) {
                                z.controls.alert({
                                    type: "danger",
                                    header: z.ll("SaveFailed"),
                                    message: z.ll("PreferencesSaveFailedMessage")
                                });

                                popUp.get("#UserPreferencesWindow").enableAll();
                                popUp.window.wrapper.unmask();
                            }
                        });
                    }
                }
            }]
        }


        var popUp = z.controls.popUp({
            id: "UserPreferencesWindow",
            title: z.ll("UserPreferences"),
            width: 850,
            buttons: [
                {
                    name: z.ll("Cancel")
                },
                ...passwordResetButton(),
                {
                    id: "DisplayIdsButton",
                    name: showIdsInGrids.Value == "true" ? z.ll("RemoveIdsInGrids") : z.ll("DisplayMoreIdsInGrids")
                },
                {
                    id: "LanguageButton",
                    name: z.ll("Language")
                },
                ...saveButton()
            ]
        });

        popUp.get("#LanguageButton").tie("click", function () {
            var languagePopUp = z.controls.popUp({
                id: "LanguageWindow",
                title: z.ll("Language"),
                width: 300,
                buttons: [
                    {
                        name: z.ll("Cancel")
                    },
                    {
                        name: z.ll("Save"),
                        clickEvent: function (e) {
                            e.preventDefault();
                            languagePopUp.window.wrapper.mask();
                            var languagePreference;
                            var selectedLanguage = languagePopUp.get("#Language").val();

                            var companyData = JSON.parse(localStorage.companyData);

                            _.forEach(companyData.UserPreferences, function (userPreference, index) {
                                if (userPreference.UserPreferenceNumber == "Language") {
                                    languagePreference = userPreference;
                                    companyData.UserPreferences[index].Value = selectedLanguage;
                                    localStorage.companyData = JSON.stringify(companyData);
                                }
                            });

                            var dto;
                            if (languagePreference) {
                                dto = {
                                    Id: languagePreference.Id,
                                    Value: selectedLanguage
                                };
                            } else {
                                dto = {
                                    UserId: z.user.loginData.UserId,
                                    UserPreferenceNumber: "Language",
                                    Value: selectedLanguage
                                };
                            }

                            z.util.updateEntity({
                                dto: dto,
                                entityType: "UserPreferences",
                                success: function (response) {
                                    z.controls.alert({ type: "success", message: z.ll("LanguageChanged"), wait: 5000 });

                                    if (!languagePreference) {
                                        var select = "UserId, UserPreferenceNumber, Value";
                                        var filter = `UserId eq ${z.user.loginData.UserId} and UserPreferenceNumber eq Language`;
                                        z.ajax({
                                            type: "GET",
                                            url: `UserPreferences?$select=${select}&$filter=${filter}`,
                                        }).done(function (data) {
                                            var result = data.d.results[0];
                                            companyData.UserPreferences.push(result);
                                            localStorage.companyData = JSON.stringify(companyData);
                                            languagePopUp.window.close();
                                        });
                                    } else {
                                        languagePopUp.window.close();
                                    }
                                }
                            });
                        }
                    }
                ]
            });

            var languageGuts = languageView();
            languageGuts.options.zScreen = languagePopUp;
            languageGuts.render(languagePopUp.guts);

            languagePopUp.guts.zValidator();
            z.bind({ container: languagePopUp.guts, bind: ".bind-label", data: z.LocalizedLanguage });

            initializeLanguageList(languagePopUp);

        });

        popUp.get("#DisplayIdsButton").tie("click", function (e) {
            e.preventDefault();
            let button = popUp.get("#DisplayIdsButton");
            let showIdsInGridsCurrentValue = _.find(z.user.companyData.UserPreferences, function (userPreference: any) {
                return userPreference.UserPreferenceNumber == "ShowIdsInGrids";
            }) || {};

            popUp.window.wrapper.mask();
            if (showIdsInGridsCurrentValue.Value == "true") {
                let data = {
                    Id: showIdsInGridsCurrentValue.Id,
                    UserId: z.user.loginData.UserId,
                    UserPreferenceNumber: "ShowIdsInGrids",
                    Value: "false"
                };
                z.ajax({
                    url: "UserPreferences",
                    type: showIdsInGridsCurrentValue.Id ? "PATCH" : "POST",
                    data: data
                }).done(response => {
                    button.text(z.ll("DisplayMoreIdsInGrids"));
                    popUp.window.wrapper.unmask();
                    showIdsInGridsCurrentValue.Value = "false";
                    localStorage.companyData = JSON.stringify(z.user.companyData);
                    z.controls.alert({
                        header: z.ll("SaveSuccessful"),
                        message: z.ll("SaveSuccessful"),
                        type: "success"
                    });
                });
            } else {
                let data = {
                    Id: showIdsInGridsCurrentValue.Id,
                    UserId: z.user.loginData.UserId,
                    UserPreferenceNumber: "ShowIdsInGrids",
                    Value: "true"
                };
                z.ajax({
                    url: "UserPreferences",
                    type: showIdsInGridsCurrentValue.Id ? "PATCH" : "POST",
                    data: data
                }).done(response => {
                    button.text(z.ll("RemoveIdsInGrids"));
                    popUp.window.wrapper.unmask();
                    if (showIdsInGridsCurrentValue.Id) {
                        showIdsInGridsCurrentValue.Value = "true";
                        localStorage.companyData = JSON.stringify(z.user.companyData);
                    } else {
                        data.Id = response.d.results;
                        z.user.companyData.UserPreferences.push(data);
                        localStorage.companyData = JSON.stringify(z.user.companyData);
                    }
                    z.controls.alert({
                        header: z.ll("SaveSuccessful"),
                        message: z.ll("SaveSuccessful"),
                        type: "success"
                    });
                });
            }

        });

        var initializeLanguageList = function (languagePopUp) {
            var languagePreference;
            var companyData = JSON.parse(localStorage.companyData);

            languagePreference = _.find(companyData.UserPreferences, { UserPreferenceNumber: "Language" });

            var languageList = languagePopUp.get("#Language").data("kendoDropDownList");

            if (languagePreference) {
                languagePopUp.get("#Language").data("kendoDropDownList").select(function (dataItem) {
                    return dataItem.CodeNumber == languagePreference.Value;
                });
            } else if (companyData.Settings.DefaultLocale) {
                languagePopUp.get("#Language").data("kendoDropDownList").select(function (dataItem) {
                    return dataItem.CodeNumber == companyData.Settings.DefaultLocale;
                });
            }
        };

        popUp.guts.removeClass("contents");

        var guts = userPreferencesView();
        guts.options.zScreen = popUp;
        guts.render(popUp.guts);

        popUp.guts.zValidator();
        z.bind({ container: popUp.guts, bind: ".bind-label", data: z.LocalizedLanguage });

        var userPrefs = kendo.observable({
            FirstName: z.user.loginData.FirstName,
            LastName: z.user.loginData.LastName
        });
        z.bind({ container: popUp.guts, bind: ".bind-value", data: userPrefs });
    });
}
